import { GlobalSystemColors } from './types';

export enum ThemeType {
  light,
  dark
}

export const globalSystemColors: GlobalSystemColors = {
  blue: '#4264fd',
  green: '#3db460',
  red: '#ff586d',
  kapital: '#b30838',
  yellow: '#ffb900',
  black: '#121212',
  auburnRed: '#d93d04'
};
